import { getCookie, setCookie } from 'pmt-modules/storage'

export const CONSENT_KEY = 'cookie-consent'

export const ConsentChoice = {
  ACCEPTED: 'accepted',
  DENIED: 'denied',
}

const SIX_MONTHS_MS = 6 * 30 * 24 * 60 * 60 * 1000 // ~6 mois

// null if unknown or expired. In this case, the behaviour should be as if the user denied the non-essential cookies + display the banner
// we use an (essential) cookie so it's shared between web customer & order plugin
export const getConsent = () => {
  return getCookie(CONSENT_KEY)
}

export const setConsent = choice => {
  if (choice) {
    setCookie(CONSENT_KEY, choice, SIX_MONTHS_MS)
  }
}
